import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material';
import { PasswordProtectionData } from './password-protection-data.interface';
import { PasswordProtectionService } from './password-protection.service';

@Component({
  selector: 'app-password-protection',
  templateUrl: './password-protection.component.html',
  styleUrls: ['./password-protection.component.css']
})
export class PasswordProtectionComponent implements OnInit {
  data: PasswordProtectionData;
  password: FormControl;

  constructor(
    private _passwordProtectionService: PasswordProtectionService, 
    @Inject(MAT_DIALOG_DATA) private _data: PasswordProtectionData
  ) { }


  ngOnInit() {
    if(this._data)
    {
      this.data = this._data;
    }
    else
    {
      this.data = {
        minLength: 4,
        maxLength: 20
      };
    }
    this.password = new FormControl("", [
      Validators.required,
      Validators.minLength(this.data.minLength),
      Validators.maxLength(this.data.maxLength)
    ]);
  }
  
  confirm(): void
  {
    this._passwordProtectionService.confirm(this.password.value);
  }

  confirmOnEnter(event: KeyboardEvent): void
  {
    if(this.password.valid && event.key === "Enter")
    {
      this.confirm();
    }
  }
}
